import { render, staticRenderFns } from "./SelectGeneric.vue?vue&type=template&id=bcda84e8&scoped=true&"
import script from "./SelectGeneric.vue?vue&type=script&lang=js&"
export * from "./SelectGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcda84e8",
  null
  
)

export default component.exports